"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return RectangleGroup;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
const _Group = require("../Group");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
class RectangleGroup extends _Group.ShapeGroup {
    _childAttributes() {
        // Optionally register subclass attributes here.
        const nullPoint = {
            x: null,
            y: null
        };
        this.UL = nullPoint;
        this.LR = nullPoint;
        this.rectangleWidth = 1;
        this.rectangleHeight = 1;
    }
    _unpack(shape = {}) {
        const { points = [] } = shape;
        const [UL, LR] = points;
        this.UL = UL;
        this.LR = LR;
        this.rectangleWidth = LR.x - UL.x || 1;
        this.rectangleHeight = LR.y - UL.y || 1;
    }
    _init(shape = {}, config = {}) {
        this.node = new _konva.default.Rect(_object_spread({
            id: shape.id,
            position: this.UL,
            width: this.rectangleWidth,
            height: this.rectangleHeight,
            stroke: "white",
            strokeWidth: 2,
            draggable: this.draggable,
            hitStrokeWidth: 10
        }, config));
    }
    _update(shape = {}, config = {}) {
        this.node.setAttrs({
            position: this.UL,
            width: this.rectangleWidth,
            height: this.rectangleHeight
        });
    }
    _stroke() {
        const strokeWidth = 2;
        const position = this.UL;
        const width = this.rectangleWidth;
        const height = this.rectangleHeight;
        // stroke position
        const positionOuter = {
            x: Math.max(0, position.x - strokeWidth),
            y: Math.max(0, position.y - strokeWidth)
        };
        const positionInner = {
            x: Math.max(0, position.x + strokeWidth),
            y: Math.max(0, position.y + strokeWidth)
        };
        // stroke dimensions
        const dimensionsOuter = {
            width: Math.max(0, width + 2 * strokeWidth),
            height: Math.max(0, height + 2 * strokeWidth)
        };
        const dimensionsInner = {
            width: Math.max(0, width - 2 * strokeWidth),
            height: Math.max(0, height - 2 * strokeWidth)
        };
        const group = new _konva.default.Group();
        const inner = new _konva.default.Rect(_object_spread_props(_object_spread({
            name: "rect-stroke-inner"
        }, positionInner, dimensionsInner), {
            stroke: "black",
            strokeWidth,
            listening: false
        }));
        const outer = new _konva.default.Rect(_object_spread_props(_object_spread({
            name: "rect-stroke-outer"
        }, positionOuter, dimensionsOuter), {
            stroke: "black",
            strokeWidth,
            listening: false
        }));
        group.add(inner);
        group.add(outer);
        return group;
    }
}
